/**
 * Get the proxy URL for an image (uses SEEDS API proxy to avoid CORS)
 * @param {object} image - Image object from state
 * @param {object} state - Redux state
 * @returns {string|null} - Proxy URL or null if not available
 */
const getImageDisplayUrl = (image, state) => {
    const SEEDS_API_BASE = process.env.SEEDS_URL || 'http://localhost:3000';
    
    // Priority: s3Key > imageUrl (if imageUrl is not a URL)
    // The API returns s3Key when includeSignedUrls=true, otherwise imageUrl is the S3 key
    let s3Key = image.s3Key;
    
    // If no s3Key, check imageUrl - if it's not a URL, it's the S3 key
    if (!s3Key && image.imageUrl && !image.imageUrl.startsWith('http')) {
        s3Key = image.imageUrl;
    }
    
    // If still no S3 key, check the URL map (for backwards compatibility)
    if (!s3Key && image.imageUrl) {
        const urlKey = image.imageUrl;
        if (state.scratchGui.bricklabGlobalImages.imageUrlMap[urlKey]) {
            // This is a signed URL in the map, but we want the S3 key
            // The map stores signed URLs, but we need the original key
            // For now, if we have a signed URL, we can't extract the key easily
            // So we'll use the imageUrl as-is if it's already a URL
            if (urlKey.startsWith('http')) {
                // This shouldn't happen with the new approach, but handle it
                return null;
            }
            s3Key = urlKey;
        } else if (!urlKey.startsWith('http')) {
            s3Key = urlKey;
        }
    }
    
    if (!s3Key) {
        return null;
    }
    
    // Use proxy endpoint with S3 key
    return `${SEEDS_API_BASE}/api/bricklab/images/proxy?key=${encodeURIComponent(s3Key)}`;
};

export {getImageDisplayUrl};
